import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import { mainReducers } from './mainReducers';

export const initialState = {
  isLoadingItems: false,
  isTableView: false,
  lookups: [],
  isLoadingSingleLookup: false,
  getLookupResult: {
    lookupFileToTest: {
      lookupFileToTest: null,
    },
    lookupColumnToTest: {
      lookupColumnsToTest: [],
      lookupColumnToTest: '',
    },
    lookupValueToTestFor: '',
    lookupTestResult: {
      isLoadingLookupTestResult: false,
      hasLoadedLookupTestResult: false,
      lookupTestResultRows: [],
    },
  },
  activeLookupData: {
    activeLookupId: null,
    activeLookupColumns: [],
    activeLookupRows: [],
    activeLookupTotalRows: null,
    activeLookupDisplayName: '',
    activeLookupPagination: {
      size: 50,
      skip: 0,
    },
  },
  lookupsModalData: {
    title: '',
  },
  filters: {
    lookupToSearch: '',
  },
  sorting: {
    sortBy: '',
    sortDirection: 'DESC',
  },
  pagination: {
    lookups: {
      size: 10,
      skip: 0,
      totalItemCount: 0,
    },
  },
};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...mainReducers,
});

export default reduceReducers(rootReducer);
